import _slicedToArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import styled, { css } from "styled-components";
import Heading from "../Heading";
import Stack from "../Stack";
import ButtonLink from "../ButtonLink";
import ChevronDown from "../icons/ChevronDown";
import Slide from "../utils/Slide";
import defaultTheme from "../defaultTheme";
import randomID from "../utils/randomID";
var AnimatedIcon = styled(ChevronDown).withConfig({
  displayName: "Collapse__AnimatedIcon",
  componentId: "x5d7nf-0"
})(["transition:transform ", " ease-in-out;", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.durationFast;
}, function (_ref2) {
  var expanded = _ref2.expanded;
  return expanded && css(["transform:rotate(180deg);"]);
});
AnimatedIcon.defaultProps = {
  theme: defaultTheme
};
var StyledCollapse = styled.div.withConfig({
  displayName: "Collapse__StyledCollapse",
  componentId: "x5d7nf-1"
})(["width:100%;display:block;border-bottom:1px solid ", ";padding-bottom:", ";margin-bottom:", ";:last-child,:only-child{border:0;margin:0;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.paletteCloudNormal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.spaceMedium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.spaceMedium;
});
StyledCollapse.defaultProps = {
  theme: defaultTheme
};
var StyledCollapseLabel = styled.div.withConfig({
  displayName: "Collapse__StyledCollapseLabel",
  componentId: "x5d7nf-2"
})(["width:100%;display:block;cursor:pointer;"]);
var StyledCollapseChildren = styled.div.withConfig({
  displayName: "Collapse__StyledCollapseChildren",
  componentId: "x5d7nf-3"
})(["margin-top:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.orbit.spaceXSmall;
});
StyledCollapseChildren.defaultProps = {
  theme: defaultTheme
};
var StyledActionsWrapper = styled.div.withConfig({
  displayName: "Collapse__StyledActionsWrapper",
  componentId: "x5d7nf-4"
})(["display:flex;align-items:center;"]);

var Collapse = function Collapse(_ref7) {
  var _ref7$initialExpanded = _ref7.initialExpanded,
      initialExpanded = _ref7$initialExpanded === void 0 ? false : _ref7$initialExpanded,
      expandedProp = _ref7.expanded,
      label = _ref7.label,
      children = _ref7.children,
      dataTest = _ref7.dataTest,
      onClick = _ref7.onClick,
      actions = _ref7.actions;
  var isControlledComponent = React.useMemo(function () {
    return expandedProp != null;
  }, [expandedProp]);

  var _React$useState = React.useState(isControlledComponent ? expandedProp : initialExpanded),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expandedState = _React$useState2[0],
      setExpandedState = _React$useState2[1];

  var expanded = isControlledComponent ? expandedProp : expandedState;

  var _React$useState3 = React.useState(expanded ? null : 0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      contentHeight = _React$useState4[0],
      setContentHeight = _React$useState4[1];

  var node = React.useRef(null);
  React.useEffect(function () {
    var calculateHeight = function calculateHeight() {
      if (node && node.current) {
        var _node$current$getBoun = node.current.getBoundingClientRect(),
            height = _node$current$getBoun.height;

        setContentHeight(height);
      }
    };

    calculateHeight();
    window.addEventListener("resize", calculateHeight);
    return function () {
      window.removeEventListener("resize", calculateHeight);
    };
  }, []);
  var slideID = React.useMemo(function () {
    return randomID("slideID");
  }, []);
  var labelID = React.useMemo(function () {
    return randomID("labelID");
  }, []);
  var handleClick = React.useCallback(function (event) {
    if (!isControlledComponent) {
      if (onClick) {
        onClick(event, !expanded);
      }

      setExpandedState(!expanded);
    } else if (onClick) {
      onClick(event, !expanded);
    }
  }, [expanded, isControlledComponent, onClick]);
  return React.createElement(StyledCollapse, {
    "data-test": dataTest
  }, React.createElement(StyledCollapseLabel, {
    onClick: handleClick,
    role: "button",
    "aria-expanded": expanded,
    "aria-controls": slideID,
    id: labelID
  }, React.createElement(Stack, {
    justify: "between",
    align: "center"
  }, React.createElement(Heading, {
    type: "title4",
    element: "div"
  }, label), React.createElement(Stack, {
    inline: true,
    grow: false,
    align: "center",
    spacing: "compact"
  }, React.createElement(StyledActionsWrapper, {
    onClick: function onClick(ev) {
      ev.stopPropagation();
    }
  }, actions), React.createElement(ButtonLink, {
    iconLeft: React.createElement(AnimatedIcon, {
      expanded: expanded
    }),
    transparent: true,
    size: "small",
    type: "secondary"
  })))), React.createElement(Slide, {
    maxHeight: contentHeight,
    expanded: expanded,
    id: slideID,
    ariaLabelledBy: labelID
  }, React.createElement(StyledCollapseChildren, {
    ref: node
  }, children)));
};

export default Collapse;